import * as actionTypes from '../actions/Actions';

export const goToNextStep = () => ({ type: actionTypes.GO_TO_NEXT_STEP });

export const backToPreviousStep = () => ({ type: actionTypes.BACK_TO_PREVIOUS_STEP });

export const backToFirstStep = () => ({ type: actionTypes.BACK_TO_FIRST_STEP });

export const updateOnboardingData = (onboardingData) => ({ type: actionTypes.UPDATE_ONBOARDING_DATA, onboardingData: onboardingData });